// extracted by mini-css-extract-plugin
module.exports = {"social-login":"_2N39P","title":"_9y1yA","buttons":"_96JA9","button":"sEXAZ","icon":"QlWr-","error":"_1HqKB"};